/** @format */
import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { useStyles } from './style';



const ButtonLoading = ({ name, loading, disabled = null, color, ...rest }) => {
  const classes = useStyles();
  return (
    <Button
      {...rest}
      color={color === 'default' ? 'inherit' : color}
      disabled={disabled === null ? loading : disabled}
    >
      {name}
      {loading && <CircularProgress size={20} className={classes.buttonProgress} />}
    </Button>
  );
};

export default ButtonLoading;
